import { createSelector } from 'reselect';
import { resource } from './actions';
export const selectCountryList = state => state.gandiReduxPlaces.countries;
export const selectIsFetchingCountryList = state => resource.selectIsFetching(state, 'default');
export const selectIsLoadedCountryList = state => resource.selectIsLoaded(state, 'default');
export const selectIsFailureCountryList = state => resource.selectIsFailure(state, 'default');
export const selectIsToRefetchCountryList = state => resource.selectIsToRefetch(state, 'default');
export const selectOneCountry = createSelector(selectCountryList, (state, alpha2) => alpha2, (countries, alpha2) => {
  const filter = countries.filter(country => country.alpha2 === alpha2);
  if (filter.length) {
    return filter[0];
  }
  return undefined;
});
export const selectLastAskedCountry = state => state.gandiReduxPlaces.lastAskedCountry;
export const selectRawCountry = createSelector(state => state, (state, alpha2) => alpha2, selectLastAskedCountry, (state, alpha2, lastAskedCountry) => {
  if (alpha2) {
    return state.gandiReduxPlaces[alpha2];
  }
  if (lastAskedCountry) {
    return state.gandiReduxPlaces[lastAskedCountry];
  }
  return undefined;
});
const EMPTY_CURRENCIES = [];
export const selectCurrencies = createSelector(selectRawCountry, countryState => countryState ? countryState.currencies : EMPTY_CURRENCIES);
export const selectBuId = createSelector(selectRawCountry, countryState => countryState ? countryState.bu_id : undefined);
export const selectIsMandatorySubdivision = createSelector(selectRawCountry, countryState => countryState ? countryState.mandatory_subdivision : false);
export const selectIsMandatoryZipCode = createSelector(selectRawCountry, countryState => countryState ? countryState.mandatory_zipcode : false);
export const selectPhonePrefix = createSelector(selectRawCountry, countryState => countryState ? countryState.phone_prefix : undefined);
const EMPTY_TAXES = [];
export const selectTaxes = createSelector(selectRawCountry, countryState => countryState && Array.isArray(countryState.taxes) ? countryState.taxes : EMPTY_TAXES);
export const selectHasVat = createSelector(selectTaxes, taxes => taxes.length ? taxes[0].rate !== 0 : false);
const EMPTY_SUBDIVISIONS = [];
export const selectSubdivisions = createSelector(selectRawCountry, countryState => countryState ? countryState.subdivisions : EMPTY_SUBDIVISIONS);
export const createListTypeAndSort = subByType => {
  const valuesTypeSub = Object.keys(subByType).map(type => {
    const obj = {};
    const typeSubs = subByType[type];
    obj[type] = typeSubs.map(sub => ({
      text: sub.name,
      value: sub.code
    }));
    return obj;
  });
  const valuesTypeSubSort = [...valuesTypeSub];
  valuesTypeSubSort.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
  return valuesTypeSubSort;
};
const EMPTY_TYPE_SUBDIVISIONS = {};
export const selectTypeSubdivisions = createSelector([selectRawCountry], countryState => {
  if (!countryState || !countryState.subdivisions || !countryState.subdivisions.length) {
    return EMPTY_TYPE_SUBDIVISIONS;
  }
  const hasParents = countryState.subdivisions.every(sub => sub.parent);
  const subByType = countryState.subdivisions.reduce((acc, sub) => {
    const parentOrType = hasParents && sub.parent ? sub.parent : sub.type_label || sub.type;
    if (!Object.hasOwnProperty.call(acc, parentOrType)) {
      acc[parentOrType] = [];
    }
    acc[parentOrType].push(sub);
    return acc;
  }, {});
  return subByType;
});
export const selectOneSubdivision = createSelector(state => state, (state, props) => props, (state, props) => typeof props === 'string' ? selectSubdivisions(state) : selectSubdivisions(state, props.alpha2), (state, props, subdivisions) => {
  const code = typeof props === 'string' ? props : props.code;
  const filter = subdivisions.filter(subdivision => subdivision.code === code);
  if (filter.length) {
    return filter[0];
  }
  return undefined;
});
export const selectSubdivisionName = createSelector(selectOneSubdivision, subdivision => subdivision ? subdivision.name : undefined);
export const selectIsFetchingCountry = (state, alpha2) => resource.selectIsFetchingOne(state, alpha2);
export const selectIsLoadedCountry = (state, alpha2) => resource.selectIsLoadedOne(state, alpha2);
export const selectIsFailureCountry = (state, alpha2) => resource.selectIsFailureOne(state, alpha2);
export const selectIsToRefetchCountry = (state, alpha2) => resource.selectIsToRefetchOne(state, alpha2);
export const selectCountryName = createSelector(selectRawCountry, (state, alpha2) => alpha2 ? selectOneCountry(state, alpha2) : undefined, (countryState, country) => {
  if (country) {
    return country.name;
  }
  return countryState ? countryState.name : undefined;
});